import React, {useEffect, useState} from 'react';
import ParticlesAuth from "./ParticlesAuth";
import { Spinner, Button, Label, Input, FormFeedback, Alert } from 'reactstrap';

//redux
import {useSelector, useDispatch} from "react-redux";

import {Link, useSearchParams} from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
import axios from "../../helpers/axiosConfig";
import { setToken } from "../../slices/authSlice";
import { getPrimaryShopId } from "../../helpers/shop";
// Formik validation
import * as Yup from "yup";
import {useFormik} from "formik";

// actions
import {loginUser, resetLoginFlag} from "../../slices/thunks";

import logoWhite from "../../assets/img/core-img/logo-white.png";
import {createSelector} from 'reselect';

const Login = (props: any) => {
    const dispatch: any = useDispatch();
    const [searchParams] = useSearchParams();
    const requiresLoginForVerification = searchParams.get("reason") === "email-verification";
    const selectLayoutState = (state: any) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            authUser: state.auth.user,
            user: state.Account.user,
            error: state.Login.error,
            errorMsg: state.Login.errorMsg,
        })
    );
    // Inside your component
    const {
        authUser, user, error, errorMsg
    } = useSelector(loginpageData);

    const [userLogin, setUserLogin] = useState<any>([]);
    const [loader, setLoader] = useState<boolean>(false);

    useEffect(() => {
        if (user && user) {
            const updatedUserData = user.user.email;
            const updatedUserPassword = user.user.confirm_password;
            setUserLogin({
                email: updatedUserData,
                password: updatedUserPassword
            });
        }
    }, [user]);

    useEffect(() => {
        let isMounted = true;

        const verifySession = async () => {
            try {
                const response = await axios.get("/api/user", { withCredentials: true });
                const responseData = response?.data ?? response;
                const userData = responseData?.user ?? responseData;

                if (userData && isMounted) {
                    const session = { user: userData };
                    localStorage.setItem("authUser", JSON.stringify(session));
                    dispatch(setToken(session));
                    if (!userData?.email_verified_at) {
                        props.router.navigate("/verify-email");
                    } else if (!getPrimaryShopId(userData)) {
                        props.router.navigate("/create-shop");
                    } else {
                        props.router.navigate("/order");
                    }
                }
            } catch (error) {
                // Ignore errors to keep login page accessible
            }
        };

        if (authUser) {
            if (!authUser?.email_verified_at) {
                props.router.navigate("/verify-email");
            } else if (!getPrimaryShopId(authUser)) {
                props.router.navigate("/create-shop");
            } else {
                props.router.navigate("/order");
            }
            return undefined;
        }

        verifySession();

        return () => {
            isMounted = false;
        };
    }, [authUser, dispatch, props.router]);

    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email,
            password: userLogin.password,
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Vui lòng nhập email"),
            password: Yup.string().required("Vui lòng nhập mật khẩu"),
        }),
        onSubmit: (values) => {
            dispatch(loginUser(values, props.router.navigate));
            setLoader(true)
        }
    });

    useEffect(() => {
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
                setLoader(false)
            }, 3000);
        }
    }, [dispatch, errorMsg]);

    document.title = "Hệ thống quản lý đặt món - Đăng nhập";
    return (
        <ParticlesAuth>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-10 col-lg-8">
                        <img className="big-logo" src={logoWhite} alt="logo"/>
                        <div className="register-form mt-5">
                            <form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                                action="#"
                            >
                                {requiresLoginForVerification && (
                                    <Alert color="warning">Bạn cần đăng nhập để xác nhận địa chỉ email.</Alert>
                                )}
                                {error && error ? (<Alert color="danger"> {error} </Alert>) : null}
                                <div className="form-group text-start mb-4">
                                    <span>Địa chỉ Email</span>
                                    <Label>
                                        <i className="mdi mdi-email-outline"></i>
                                    </Label>
                                    <Input
                                        name="email"
                                        className="form-control"
                                        placeholder="email@example.com"
                                        type="email"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.email || ""}
                                        invalid={
                                            validation.touched.email && validation.errors.email ? true : false
                                        }
                                    />
                                    {validation.touched.email && validation.errors.email ? (
                                        <FormFeedback
                                            type="invalid">{validation.errors.email}</FormFeedback>
                                    ) : null}
                                </div>
                                <div className="form-group text-start mb-4">
                                    <span>Mật khẩu</span>
                                    <Label>
                                        <i className="mdi mdi-lock-outline"></i>
                                    </Label>
                                    <Input
                                        name="password"
                                        value={validation.values.password || ""}
                                        type="password"
                                        className="form-control pe-5"
                                        placeholder="********"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        invalid={
                                            validation.touched.password && validation.errors.password ? true : false
                                        }
                                    />
                                    {validation.touched.password && validation.errors.password ? (
                                        <FormFeedback
                                            type="invalid">{validation.errors.password}</FormFeedback>
                                    ) : null}
                                </div>
                                <Button
                                    className="btn btn-warning btn-lg w-100"
                                    disabled={loader && true}
                                    type="submit">
                                        {
                                            loader &&
                                            <Spinner size="sm" className='me-2'></Spinner>
                                        }
                                        Đăng Nhập
                                </Button>
                            </form>
                        </div>
                        <div className="login-meta-data">
                            <Link className="forgot-password d-block mt-3 mb-1" to="/forgot-password">Quên Mật Khẩu?</Link>
                            <p className="mb-0">Bạn chưa có tài khoản? <Link to="/register">Đăng Ký</Link></p>
                        </div>
                    </div>
                </div>
            </div>
        </ParticlesAuth>
    );
};

export default withRouter(Login);
